import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const storeDevtoolsModule = [
  StoreDevtoolsModule.instrument({
    maxAge: 50 // Retains last 50 states
  })
];
